/**
 * Host adapter for Microsoft Excel
 *
 * Extracts content from Excel workbooks using the Excel JavaScript API.
 */
export class ExcelAdapter {
    hostType = 'excel';
    async getDocumentContext() {
        try {
            const result = await Excel.run(async (context) => {
                const workbook = context.workbook;
                const worksheets = workbook.worksheets;
                worksheets.load('items/name');
                await context.sync();
                const sheetContents = [];
                let totalSheets = 0;
                for (const worksheet of worksheets.items) {
                    totalSheets++;
                    const usedRange = worksheet.getUsedRangeOrNullObject();
                    usedRange.load('values');
                    await context.sync();
                    if (!usedRange.isNullObject && usedRange.values) {
                        const sheetHeader = `=== Sheet: ${worksheet.name} ===`;
                        const rows = usedRange.values.map((row) => row
                            .map((cell) => cell !== null && cell !== undefined ? String(cell) : '')
                            .join('\t'));
                        sheetContents.push([sheetHeader, ...rows].join('\n'));
                    }
                    else {
                        sheetContents.push(`=== Sheet: ${worksheet.name} ===\n(empty)`);
                    }
                }
                return {
                    content: sheetContents.join('\n\n'),
                    sheetCount: totalSheets,
                };
            });
            return {
                content: result.content || 'Workbook is empty',
                metadata: {
                    source: 'excel-workbook',
                    sheetCount: String(result.sheetCount),
                },
            };
        }
        catch (error) {
            console.error('[ExcelAdapter] Error extracting workbook content:', error);
            return {
                content: 'Unable to extract workbook content',
                metadata: {
                    source: 'excel-workbook',
                    error: error instanceof Error ? error.message : 'Unknown error',
                },
            };
        }
    }
    getDeploymentType() {
        return 'AddinExcel';
    }
}
